import { useAuth, useOrgUser } from '@cibo/profile'
import { LineLimitTypography } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAgreementNotes } from '../queries'
import { AgreementShape } from '../types'

interface LastCommentCellProps extends Pick<AgreementShape, 'agreementId'> {
  author?: boolean
}

export const LastCommentCell = ({ agreementId, author }: LastCommentCellProps) => {
  const { t } = useTranslation('@cibo/impact/LastCommentCell')
  const notes = useAgreementNotes(agreementId)
  const user = useOrgUser(notes.data?.[0]?.userId)
  const { userId: myUserId } = useAuth()
  if (!notes.isFetched || !notes.data || notes.data.length === 0) return null

  const { note, userId } = notes.data[0]

  return (
    <Stack>
      <LineLimitTypography lineLimit={1} variant="body2">
        {note}
      </LineLimitTypography>
      {author &&
        (userId === myUserId ? (
          <Typography variant="caption">{t('byYou')}</Typography>
        ) : (
          <Typography variant="caption">
            {t('byUser', {
              user: !!user.data?.displayNameFull,
            })}
          </Typography>
        ))}
    </Stack>
  )
}
